import React, { useState, useEffect, forwardRef } from "react";
import { Tooltip } from "antd";
import { useDispatch } from "react-redux";
import SectionHeader from "../../components/global/SectionHeader";
import { Spin, notification, Select, Button } from "antd";
import { Link } from "react-router-dom";
import MaterialTable from "material-table";
import AddBox from "@material-ui/icons/AddBox";
import ArrowDownward from "@material-ui/icons/ArrowDownward";
import Check from "@material-ui/icons/Check";
import ChevronLeft from "@material-ui/icons/ChevronLeft";
import ChevronRight from "@material-ui/icons/ChevronRight";
import Clear from "@material-ui/icons/Clear";
import DeleteOutline from "@material-ui/icons/DeleteOutline";
import Edit from "@material-ui/icons/Edit";
import FilterList from "@material-ui/icons/FilterList";
import FirstPage from "@material-ui/icons/FirstPage";
import LastPage from "@material-ui/icons/LastPage";
import Remove from "@material-ui/icons/Remove";
import SaveAlt from "@material-ui/icons/SaveAlt";
import Search from "@material-ui/icons/Search";
import ViewColumn from "@material-ui/icons/ViewColumn";
import { useSidebar } from "../../components/provider/Provider";
import Layout from "../../components/global/layout";
import ApiClient from "../../methods/api/apiClient";
import { CKEditor } from "@ckeditor/ckeditor5-react";
import ClassicEditor from "@ckeditor/ckeditor5-build-classic";
import { FaRegCopy } from "react-icons/fa";
import { FaRegRectangleList } from "react-icons/fa6";
import { IoMdAddCircleOutline } from "react-icons/io";

const { Option } = Select;

const Reviewproject = () => {
  const { setCourseId } = useSidebar();
  const userid = localStorage.getItem("USERID");
  const [array, setArray] = useState([]);
  const dispatch = useDispatch();
  const [loading, setLoading] = useState(false);
  const [copied, setCopied] = useState(false);
  const [reason, setReviewModal] = useState(false);
  const [employee, setEmployee] = useState([]);
  const role =localStorage.getItem('role')
  const [form, setFrom] = useState({
    employeeId: "",
    projectId: "",
    reviewType: "Code Review",
    description: "",
    addedBy: userid ? userid : "",
  });

  useEffect(() => {
    projectAssign();

  }, []);

  const projectAssign = () => {
    setLoading(true);
    let data = {
      id: userid,
    };
    ApiClient.allApi("user/assignedProjects", data).then((res) => {
      if (res.success) {
        setArray(res.data);
      } else {
        notification.error({
          message: res.message,
        });
      }
      setLoading(false);
    });
  };
  const getMember = (e) => {
    setLoading(true);
    let data = {
      // sortBy: "asc",
      // count: 10000,
      id:e
    };
    ApiClient.allApi("getProjectMembers", data).then((res) => {
      if (res.success) {
        let data=''
        data=res.data.members.filter((res)=>{return res.id!=userid })


        setEmployee(data);


      }
      setLoading(false);
    });
  };

  const chapterIdHandle = (id) => {

    getMember(id)
    if (id) {
      setReviewModal(true);
      setFrom({ ...form, projectId: id })
    } else {
      setReviewModal(false);
    }
  };

  const handleCopy = (e) => {
    navigator.clipboard.writeText(e)
      .then(() => {
        setCopied(true);

        setTimeout(() => setCopied(false), 2000); // Reset the copied status after 2 seconds
      })
      .catch((err) => console.error("Failed to copy: ", err));
      notification.success(
        {
          message: 'Copied!',
        }
      )
  };

  const OnSubmit = (e) => {
    e.preventDefault();



    if (form.employeeId == '', form.projectId == '', form.description == '') {
      notification.error('Answer is')
      return

    } else {
      let data = {
        ...form
      }
      ApiClient.post('project-review', data).then((res) => {
        if (res.success) {


          notification.success(
            {
              message: res.message,
            }
          )
          setReviewModalModal()
        } else {
          notification.error(
            {
              message: res.error.message,
            }
          )

        }
      })
    }

  };
  const setReviewModalModal = (e) => {
    setReviewModal(false);
    setFrom({ ...form, employeeId: '', description: '', projectId: '' })
    console.log(form);

  };

  const columns = [
    {
      title: "Project Name",
      dataIndex: "name",
      field: "name",
      render: (text, record) => (
        <>
          {text && text?.name ? (
            <Link to={`/projectDetail?id=${text.id}`} className="text">
              <Tooltip title="View">
                <span className="text-link">{text && text.name}</span>
              </Tooltip>
            </Link>
          ) : (
            "--"
          )}
        </>
      ),
    },
   
   ...(role!='qa' &&  role!='bde'?[{
      title: "Api Clone Link/Branch",
      dataIndex: "name",
      field: "name",
      render: (text, record) => (
        <>
          {text && text?.backend_clone_link ? (
            <div className="d-flex align-items-center gap-2">
              {text.backend_clone_link ? (
                <Tooltip title="Copy link">
                <span className="" onClick={() => handleCopy(text.backend_clone_link)}>
                  <FaRegCopy style={{ fontSize: "15px", cursor: "pointer" }} />
                </span>
                </Tooltip>
              ) : (
                ""
              )}
              <span className="overflow-txt">
                {text && text.backend_clone_link}({text.updated_branch_api})
              </span>
              <span >
               /{text.updated_branch_api}
              </span>
              </div>
          ) : (
            "--"
          )}
        </>
      ),
    }] : []),

   ...(role!='qa' &&  role!='bde')?[ {
      title: "Admin Clone Link/Branch",
      dataIndex: "name",
      field: "name",
      render: (text, record) => (
        <>
          {text && text?.admin_clone_link ? (
            <div className="d-flex align-items-center gap-2">
              {text.updated_branch_admin ? (
                  <Tooltip title="Copy link">
                <span className="" onClick={() => handleCopy(text.updated_branch_admin)}>
                  <FaRegCopy style={{ fontSize: "15px", cursor: "pointer" }} />
                </span>
              </Tooltip>
              ) : (
                ""
              )}
              <span className="overflow-txt">
                {text && text.admin_clone_link}({text.updated_branch_admin})
              </span>
              <span>
               /{text.updated_branch_admin}
              </span>
              </div>
          ) : (
            "--"
          )}
        </>
      ),
    }]:[],

 ...(role!='qa' &&  role!='bde')?[   {
      title: "Frontend Clone Link/Branch",
      dataIndex: "name",
      field: "name",
      render: (text, record) => (
        <>
          {text && text?.frontend_clone_link ? (
            <div className="d-flex align-items-center gap-2">
              {text.updated_branch_frontend ? (
                <Tooltip title="Copy link">
                <span
                  onClick={() => handleCopy(text.updated_branch_frontend)}
                  className=""
                >
                  <FaRegCopy style={{ fontSize: "15px", cursor: "pointer" }} />
                </span>
              </Tooltip>
              ) : (
                ""
              )}
              <span className="overflow-txt">
                {text && text.frontend_clone_link}(
                {text.updated_branch_frontend})
              </span>
              <span >
                /
                {text.updated_branch_frontend}
              </span>
              </div>
          ) : (
            "--"
          )}
        </>
      ),
    }]:[],
    {
      title: "Give Review",
      dataIndex: "name",
      field: "name",
      render: (text, record) => (
        <>
          {text && text?.frontend_clone_link ? (
            <> <Tooltip title="Add">
              <span onClick={() => chapterIdHandle(text.id)}><IoMdAddCircleOutline style={{ fontSize: "20px", cursor: "pointer" }} /></span>
            </Tooltip>
              <Link to={`/givenReview/${text.id}`} className="text-decoration-none">
                <Tooltip title="View">
                  <span > <FaRegRectangleList style={{ fontSize: "20px", cursor: "pointer" }} /></span>
                </Tooltip>
              </Link>
            </>) : (
            "--"
          )}
        </>
      ),
    },
  ];

  const newlyAddedChapter =
    array && array.length
      ? array.map((items) => {
        return {
          ...items,
        };
      })
      : [];

  const tableIcons = {
    Add: forwardRef((props, ref) => <AddBox {...props} ref={ref} />),
    Check: forwardRef((props, ref) => <Check {...props} ref={ref} />),
    Clear: forwardRef((props, ref) => <Clear {...props} ref={ref} />),
    Delete: forwardRef((props, ref) => <DeleteOutline {...props} ref={ref} />),
    DetailPanel: forwardRef((props, ref) => (
      <ChevronRight {...props} ref={ref} />
    )),
    Edit: forwardRef((props, ref) => <Edit {...props} ref={ref} />),
    Export: forwardRef((props, ref) => <SaveAlt {...props} ref={ref} />),
    Filter: forwardRef((props, ref) => <FilterList {...props} ref={ref} />),
    FirstPage: forwardRef((props, ref) => <FirstPage {...props} ref={ref} />),
    LastPage: forwardRef((props, ref) => <LastPage {...props} ref={ref} />),
    NextPage: forwardRef((props, ref) => <ChevronRight {...props} ref={ref} />),
    PreviousPage: forwardRef((props, ref) => (
      <ChevronLeft {...props} ref={ref} />
    )),
    ResetSearch: forwardRef((props, ref) => <Clear {...props} ref={ref} />),
    Search: forwardRef((props, ref) => <Search {...props} ref={ref} />),
    SortArrow: forwardRef((props, ref) => (
      <ArrowDownward {...props} ref={ref} />
    )),
    ThirdStateCheck: forwardRef((props, ref) => (
      <Remove {...props} ref={ref} />
    )),
    ViewColumn: forwardRef((props, ref) => <ViewColumn {...props} ref={ref} />),
  };
  return (
    <Layout>
      <div>
        <div className="main-content">
          <div className="section table table-striped">
            <div className="headings">
              <SectionHeader title="Review Projects" />
            </div>
            <Spin spinning={loading}>
              <MaterialTable
                options={{
                  showTitle: false,
                  pageSize: 10,
                  pageSizeOptions: [10, 20, 30, 40, 50],
                  emptyRowsWhenPaging: false,
                }}
                columns={columns}
                data={newlyAddedChapter}
                icons={tableIcons}
              />
            </Spin>
          </div>
        </div>
      </div>

      {reason ? (
        <div class="modal d-block scroll_fade">
          <div class="modal-dialog review-modal">
            <div class="modal-content border-0 p-3 rounded-0 bg_congoratulations">
              <div class="mb-2 textend_modal">
                <div className="d-flex align-items-center justify-content-between">
                  <h5>Give Review</h5>

                  <button
                    type="button"
                    class="btn-close ms-auto"
                    onClick={() => setReviewModalModal(false)}
                  >
                  </button>
                </div>
                <div
                  // class="tab-pane fade "
                  id="api"
                  role="tabpanel"
                  aria-labelledby="api-tab"
                >
                  <div className="mt-1">
                    <form onSubmit={OnSubmit}>
                      <div className="row m-0"></div>

                      <div className="row m-0">
                        <div className="col-md-12 mt-4">
                          <div className="project-wrapper d-flex flex-column">
                            <label>
                              Employee Name <span className="star">*</span>
                            </label>
                            <select
                              value={form.employeeId ? form.employeeId : ''}
                              onChange={(e) =>
                                setFrom({ ...form, employeeId: e.target.value })
                              }
                              required
                            >
                              <option value="" disabled>
                                Select Employee
                              </option>
                              {employee
                                ? employee.map((res) => (
                                  <option key={res.id} value={res.id}>
                                    {res.fullName}
                                  </option>
                                ))
                                : "No employees available"}
                            </select>
                          </div>
                        </div>
                      </div>
                      <div className="row m-0">
                        <div className="col-md-12 mt-4">
                          <div className="project-wrapper">
                            <label>
                              Description <span className="star">*</span>
                            </label>
                            <CKEditor
                              editor={ClassicEditor}
                              onChange={(event, editor) => {
                                const data = editor.getData(); // Get the content of the editor
                                setFrom({ ...form, description: data });
                              }}
                            />
                          </div>
                        </div>
                      </div>
                      <button type="submit
                      " className="btn btn-warning mt-2 d-block me-2 ms-auto">Send review</button>
                    </form>
                  </div>
                </div>

              </div>
            </div>
          </div>
        </div>
      ) : (
        ""
      )}
    </Layout>
  );
};

export default Reviewproject;
